export const ActivityCurriculum = {
  TeacherCreated: "Teacher-Created",
  IEW: "Institute for Excellence in Writing (IEW)",
  OrtonGillingham: "Orton-Gillingham",
  AP: "Advanced Placement (AP)",
  IB: "International Baccalaureate (IB)",
  AllAboutSpelling: "All About Spelling",
  Other: "Other",
  SaxtonMath: "Saxon Math",
  SingaporeDimensionsMath: "Singapore Dimensions Math",
  MathUSee: "Math-U-See",
  EurekaMath: "Eureka Math",
  CollegeBoardAdvancedPlacement: "College Board Advanced Placement",
  InternationalBaccalaureate: "International Baccalaureate",
} as const;

export function isActivityCurriculum(
  curriculum: string
): curriculum is (typeof ActivityCurriculum)[keyof typeof ActivityCurriculum] {
  return Object.values(ActivityCurriculum).includes(curriculum as any);
}
